export function isBannerflowEnvironment(adEnvironment) {
    return [2 /* AdEnvironment.Preview */, 4 /* AdEnvironment.ImageGenerator */, 5 /* AdEnvironment.VideoGenerator */].includes(adEnvironment);
}
